import { SITE } from '@/constants';

export default function Footer() {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 pt-20 md:pt-28 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-6">
            <img
              src="https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/6c598d678e92210efe7f9c93b8522392.jpeg"
              alt="AM Estudio"
              className="h-14 md:h-20 w-auto mb-5"
            />
            <p className="overline text-white/50">Arquitectura · Diseño · Construcción</p>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-white/40 mb-5">Contacto</p>
            <ul className="space-y-3 text-sm text-white/80">
              <li>
                <a href={SITE.instagram} target="_blank" rel="nofollow noopener noreferrer" className="u-link hover:text-white transition-colors">
                  Instagram
                </a>
              </li>
              <li>
                <a href={SITE.whatsappLink} target="_blank" rel="nofollow noopener noreferrer" className="u-link hover:text-white transition-colors">
                  WhatsApp
                </a>
              </li>
              <li>
                <a href={`mailto:${SITE.email}`} className="u-link hover:text-white transition-colors">
                  Correo
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-white/40 mb-5">Ubicación</p>
            <p className="text-sm text-white/80">{SITE.location}</p>
          </div>
        </div>

        <div className="mt-16 md:mt-20 pt-8 border-t border-white/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} AM ESTUDIO. Todos los derechos reservados.
          </p>
          <p className="text-xs text-white/40">
            Diseño arquitectónico, interiores y construcción en San Luis Potosí.
          </p>
        </div>
      </div>
    </footer>
  );
}